import SignIn from '../page/signin'
import MainRoute from '../page/main/route'

export default {
  routes: [{
      path: '/',
      redirect: '/SignIn'
    },
    {
      path: '/SignIn',
      name: 'SignIn',
      component: SignIn
    },
    MainRoute
  ]
}



// WEBPACK FOOTER //
// ./src/route/index.js